import React from 'react';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router';

const Loading=({message='Loading...'}) =>{
	const history =useHistory();
	return (
		<div className="mainSpace" style={{ textAlign: "center", marginTop: "15em" }}>
		  <h1>
			<span className="spChar">{message.charAt(0)}</span>{message.slice(1)} <br />
			<Button variant="outline-primary" onClick={()=>history.goBack()}>Go Back</Button>
		  </h1>
		</div>
	  );
}

export default Loading;